import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-calendar-icon',
  templateUrl: './general-calendar.component.html'
})
export class GeneralCalendarComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
